import BaseViz from './BaseViz'
import ScatterPlotChart from '../charts/ScatterPlotChart'
import HeatMapDataController from '../viz_behaviors/HeatMapDataController'
import { scaleLinear as d3_scaleLinear } from 'd3-scale'
export default class HeatMapViz extends BaseViz {
  static defaultConfig = {
    sizeAttr: null,
    mode: 'grid',

    valueFormat: {
      type: [String, Array, Function, null],
      default: null,
    },
    unit: {
      type: [String, Boolean, null],
      default: false,
    },
    AxisHelper: {
      x: {
        trimThreshold: {
          nonEditable: true,
        },
        valueFormat: {
          nonEditable: true,
        },
        unit: {
          nonEditable: true,
        },
        showTickValues: {
          nonEditable: true,
        },
        scale: {
          value: 'band',
          options: ['band'],
          nonEditable: true,
          exposed: false,
        },
        getExtent: function (data) {
          return data.map(d => d.x)
        },
        tickMatchData: {
          nonEditable: true,
          exposed: false,
        },
      },
      y: {
        trimThreshold: {
          nonEditable: true,
        },
        valueFormat: {
          nonEditable: true,
        },
        unit: {
          nonEditable: true,
        },
        scale: {
          value: 'band',
          options: ['band'],
          nonEditable: true,
        },
        getExtent: function (data) {
          return data.map(d => d.y)
        },
      },
      zoom: {
        value: false,
        nonEditable: true,
      },
    },
    minSize: {
      exposed: false,
    },
    maxSize: {
      value: 0,
      exposed: false,
    },
    showLabels: {
      nonEditable: true,
      exposed: false,
    },
    ItemsHelper: {
      colorScale: {
        value: {
          scaleSteps: 5,
          interpolationType: 'linear',
          scaleOption: 'gradient',
          opacityMapValue: 100,
          colorRange: ['#BBD6E8', '#15537E'],
          customSteps: null,
        },
      },
      colorKey: 'color',
    },

    TooltipBehavior: {
      getHtml: function (d) {
        return `
          <div class="important">${this.valueWithUnit(d.color)}</div>
          <div>${this.valueWithUnit(d.x, 'x')} | ${this.valueWithUnit(d.y, 'y')}</div>`
      },
    },
  }
  static chartClass = ScatterPlotChart
  static dataControllerClass = HeatMapDataController
}
